
































import {Component, Prop, Vue} from "vue-property-decorator";
import SearchBox from "@/components/SearchBox.vue";
import GroupList from "@/components/group/GroupList.vue";
import {Enterprise} from "@/types/core";
import {curEnterpriseService, EnterpriseService, GetEnterpriseQuery} from "@/services/EnterpriseService";
import PageNav from "@/components/PageNav.vue";
import {curPref} from "@/services/Preferences";

@Component({
  components: {
    GroupList,
    SearchBox,
    PageNav,
  },
})
export default class EnterpriseList extends Vue {

  @Prop({ default: {}, type: Object}) bus!: Vue;

  private enterpriseService:EnterpriseService = curEnterpriseService;

  errorMsg:string = '';
  enterprises:Enterprise[] = [];

  pageSize:number = 10;
  httpBusy:boolean = false;
  totalNumberOfPages:number = 10;
  searchTerm = curPref.retrieve('v3-groups-search-term', '');

  async mounted() {
    await this.loadPage(0);
  }

  get showPageNav():boolean {
    return this.totalNumberOfPages > 0 && this.errorMsg === '';
  }

  changePage(pageNum:number) {
    this.loadPage(pageNum);
  }

  async newSearchText(newSearchText:string) {
    // we check if the text matches the required regex
    if(newSearchText.trim() !== "" && !/^([a-z0-9\.-]{2,300})(\s[a-z0-9\.-]{2,300})*$/i.test(newSearchText))
      return;

    curPref.store('v3-groups-search-term', newSearchText);
    this.searchTerm = newSearchText;
    await this.loadPage(0);
  }

  async loadPage(pageNum:number) {
    const query:GetEnterpriseQuery = {
      pageNumber: pageNum,
      pageSize: this.pageSize,
    };

    if (this.searchTerm) {
      query.filter = this.searchTerm;
    }

    const reply = await this.enterpriseService.getEnterprises(query);

    if(reply.httpCode === 403)
      return this.$router.push({name: 'login'});

    if(reply.errorMsg)
      return this.errorMsg = `Unable to retrieve enterprises and groups: ${reply.errorMsg}`;

    this.totalNumberOfPages = reply.totalNumberOfPages ? reply.totalNumberOfPages : 0;
    if (reply.enterprisePage) {
      this.enterprises = reply.enterprisePage.enterpriseList;
    }
  }
}
